import { getAnalytics, logEvent } from 'firebase/analytics';
import {
  getSearchQueryParamsWithAD,
  getSearchQueryParamsWithoutAD,
  getUserIsLoggedIn,
  getWebUserId,
  isProductionServer,
} from './helper';
import { getWebUserType } from './getWebUserType';
import Cookies from 'js-cookie';
import {
  androidIsAppUser,
  useAndroidFireAnalyticsEvents,
} from './androidUtils';
import { isIOSAppUser, useIosLogFirebaseEvent } from './IosUtils';

export const fireEvent = (props) => {
  const analytics = getAnalytics();
  let data = props;
  const eventName = props.category;
  delete data['category'];
  data['query_params'] = getSearchQueryParamsWithoutAD();
  let ad_params = getSearchQueryParamsWithAD();
  if (ad_params?.length > 0) {
    data['ad_params'] = getSearchQueryParamsWithAD();
  }
  data['datetime'] = new Date().toISOString();
  data['user_type'] = getWebUserType();
  data['page_url'] = typeof window != 'undefined' ? window.location.href : 'NA';
  data['temp_user_type'] = getWebUserId();
  if (window?.location?.search?.includes('inExpert=true')) {
    data['type'] = 'expert_booking';
    data['term_id'] =
      new URLSearchParams(window.location.search).get('id') || 'NA';
  }
  data['page_type'] = window.location.pathname.includes('productv2')
    ? 'aplusplus_pdp'
    : 'next_pdp_test';
  if (Cookies.get('logoutUserId') && !getUserIsLoggedIn()) {
    data['user_id'] = Cookies.get('logoutUserId');
  } else {
    if (Cookies.get('react_user_properties')) {
      data['user_id'] = JSON.parse(
        Cookies.get('react_user_properties'),
      )?.user_id;
    }
  }
  if (isProductionServer()) {
    if (androidIsAppUser()) {
      useAndroidFireAnalyticsEvents(eventName, data);
    } else if (isIOSAppUser()) {
      useIosLogFirebaseEvent(eventName, data);
    } else {
      logEvent(analytics, eventName, data);
    }
  } else {
    console.log('analyticsLogEvent', eventName, JSON.stringify(data));
  }
  // if (eventName === "viewed_landing_page") {
  //     postBrowserEvent({
  //         event_name: "event_name: loaded_next_pdp",
  //         product_id: `product_id: ${data?.id}`,
  //     });
  // }
};
